import { FAQListModel } from "../../models/faqModel";

const Questions: FAQListModel[] = [
  {
    id: 1,
    title: "General / Platform",
    questions: [
      {
        question: "Does Pay@ charge an additional payment fee per fine?",
        answer: (
          <p className="faq-answer">
            No, you only pay the fine amount shown on your infringement notice.
            No additional fees are charged on this platform.
          </p>
        ),
      },
      {
        question: "What Payment Methods are available?",
        answer: (
          <p className="faq-answer">
            A fine can be paid online or in person. We offer the following
            methods: <br />
            <br />
            Digital platforms: <br />• EFT secure <br />• Mastercard <br />•
            VISA <br />
            <br />
            Smartphone Apps: <br />• MasterPass <br />• Snapscan <br />• Zapper{" "}
            <br />• Bank EFT
            <br />
            <br />
            Retailers:
            <br /> • Ackermans <br />• Checkers <br />• PEP <br />• Pick n Pay{" "}
            <br />• Shoprite <br />• SPAR. <br />
            <br />
            To pay online, click <a href="/">here</a>.
          </p>
        ),
      },
      {
        question:
          "How do I change the email address associated with my account?",
        answer: (
          <p className="faq-answer">
            Once logged in, access “My Profile” and edit your email address. You
            will be logged out and will receive an email to verify your updated
            email address.
          </p>
        ),
      },
      {
        question: "Can I change the ID number linked to my account?",
        answer: (
          <p className="faq-answer">
            No, the ID number set during registration cannot be changed.
          </p>
        ),
      },
      {
        question: "How do I reset my password?",
        answer: (
          <p className="faq-answer">
            If you forgot your password, click “Forgot password” on the “Login”
            modal to reset it. If already logged in, access “My Profile” and
            then “Change Password”.
          </p>
        ),
      },
      {
        question:
          "Why do some of my fines require registration and others not?",
        answer: (
          <p className="faq-answer">
            In the case of a warrant linked to a fine, legal documents must be
            signed and accepted, therefore registration is necessary.
          </p>
        ),
      },
      {
        question:
          "I did not receive an email address verification email. What do I do?",
        answer: (
          <p className="faq-answer">
            Login to your account and use the option to resend the verification
            email to the same or different email address. If you still haven’t
            received the email in 24 hours, please contact the City of Cape Town
            call centre on 0860103089.
          </p>
        ),
      },
      {
        question:
          "I'm a foreign national, am I able to pay fines and warrant on this site?",
        answer: (
          <p className="faq-answer">
            Yes, your fine is linked to a notice number.
          </p>
        ),
      },
      {
        question:
          "Can you stop the SMS notifications I receive about infringments?",
        answer: (
          <p className="faq-answer">
            Offence notifications are sent by the CoCT and not by the
            Paythat.co.za. Please contact the City of Cape Town call centre on
            0860103089 for further information on offence notifications.
          </p>
        ),
      },
    ],
  },
  {
    id: 2,
    title: "Paying a Fine",
    questions: [
      {
        question: "Why is my notice number not recognised?",
        answer: (
          <div className="faq-answer">
            <li>Make sure it's typed correctly (special characters).</li>
            <li>Fine could have already been paid.</li>
            <li>The fine could be at a different municipality.</li>
          </div>
        ),
      },
      {
        question: "Which municipalities can I pay on this platform?",
        answer: <p className="faq-answer">City of Cape Town fines.</p>,
      },
      {
        question:
          "Why is a fine I already paid still showing on the ID search results list?",
        answer: (
          <p className="faq-answer">
            If a recently paid fine still appears disabled on the fine list it
            means the fine is in a processing state. Please allow up to 36 hours
            for the payment to clear or for the fine to be payable again.
          </p>
        ),
      },
      {
        question:
          "Why did money leave my account, but the platform still says “Verifying Payment”?",
        answer: (
          <p className="faq-answer">
            Payment confirmation can take up to 36 hours. An email confirmation
            will be sent once the money reflects.
          </p>
        ),
      },
      {
        question:
          "The details on the fine displayed are not correct. What can I do?",
        answer: (
          <p className="faq-answer">
            Please contact the City of Cape Town call centre on 0860103089.
          </p>
        ),
      },
      {
        question: "Can I request a fine reduction or withdrawal?",
        answer: (
          <p className="faq-answer">
            This cannot be done online. Please contact the City of Cape Town
            call centre on 0860103089.{" "}
          </p>
        ),
      },
      {
        question: "How long do I have to pay a fine?",
        answer: (
          <p className="faq-answer">
            Please refer to your traffic infringement notice for the date of
            issue and payment validity period.{" "}
          </p>
        ),
      },
      {
        question:
          "I never received a payment confirmation email, does it mean the payment didn't go through?",
        answer: (
          <p className="faq-answer">
            If you provided your email address or logged into the platform, you
            should receive a payment confirmation within 36 hours. If no email
            is received after this time, please contact the City of Cape Town
            call centre on 0860103089.
          </p>
        ),
      },
    ],
  },
  {
    id: 3,
    title: "Warrant Payments",
    questions: [
      {
        question: "Do I have to appear in court to pay a fine with a warrant?",
        answer: (
          <p className="faq-answer">
            No, you can pay the warrant online without appearing in court.
          </p>
        ),
      },
      {
        question:
          "How should I handle the documents I received with my receipt?",
        answer: (
          <p className="faq-answer">
            Please retain your documentation and receipt as proof of payment.
          </p>
        ),
      },
    ],
  },
];

export default Questions;
